// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import store from './store'
import VueResource from 'vue-resource/dist/vue-resource.min.js'
// import Vueonechatapi from 'onechat_api'
// import socketonchat from 'socketonchat'
import '../node_modules/vuetify/dist/vuetify.min.css'
import VueCookies from 'vue-cookies'
import '../static/fonts/Kanit/stylesheet.css'
import '../static/fonts/Athiti/stylesheet.css'
import '../static/fonts/Poppins/stylesheet.css'
import '../static/fonts/THSarabun/stylesheet.css'
import '../static/fonts/CSChatThai/stylesheet.css'
import VueSweetalert2 from 'vue-sweetalert2'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import ReadMore from 'vue-read-more'
import VueLocalStorage from 'vue-localstorage'
import Notifications from 'vue-notification'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'vue-loaders/dist/vue-loaders.css'
import * as VueLoaders from 'vue-loaders'
import VueClipboard from 'vue-clipboard2'
import VeeValidate from 'vee-validate'
import VueTypedJs from 'vue-typed-js'
import VueParticles from 'vue-particles'
import { Cropper, PreviewResult } from 'vue-advanced-cropper'

// import vueNats from 'vue-nats'
// import io from 'socket.io-client'
import myUpload from 'vue-image-crop-upload'
// import Onechat from 'Onechat'

// Vue.use(Onechat)

Vue.use(VueParticles)
Vue.use(VueTypedJs)
Vue.use(VeeValidate)
Vue.use(VueClipboard)
Vue.use(VueLoaders)
Vue.use(Notifications)
Vue.use(VueLocalStorage)
Vue.use(require('vue-cookies'))
Vue.use(Vuetify)
Vue.use(VueResource)
Vue.use(moment)
Vue.use(momentTimezone)
Vue.use(VueSweetalert2)
Vue.use(ReadMore)
// Vue.use(Vueonechatapi)

// Vue.use(socketonchat)
Vue.use(VueCookies)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA0hGnGEcqu2w2eN5XtNUJsNF2Ylv1Vl2g',
    libraries: 'places' // necessary for places input
  }
})

// Vue.use(vueNats, {
//   url: 'ws://0.0.0.0:8080',
//   json: true, // use JSON data payload
//   reconnect: true, // always reconnect
//   maxReconnectAttempts: -1, // retry forever
//   reconnectTimeWait: 1000 // try to reconnect every second
// })

function testyBlue2() {
    return console.log('test')
  }

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App,
    Cropper,
    PreviewResult,
    myUpload
  }
})



// WEBPACK FOOTER //
// ./src/main.js